export enum WREX_CORE {
    /**
     * @value Align center
     * @description Tooltip used on buttons to center an element like an image in the structured content editor
     */
    ALIGN_CENTER = 'WREX_CORE.ALIGN_CENTER',
    /**
     * @value Align to the left
     */
    ALIGN_TO_LEFT = 'WREX_CORE.ALIGN_TO_LEFT',
    /**
     * @value Align to the right
     */
    ALIGN_TO_RIGHT = 'WREX_CORE.ALIGN_TO_RIGHT',
    /**
     * @value Editor toolbar
     * @description The label of the different editor toolbars, this label will only be read by screen readers.
     */
    EDITOR_TOOLBAR_LABEL = 'WREX_CORE.EDITOR_TOOLBAR_LABEL',
    /**
     * @value Start writing… You can add @name to mention people.
     * @description This is the placeholder of the post wrex editor. It indicates that the user can start writing here, and also that the user can mention someone with the @name syntax.
     */
    EDITOR_WITH_MENTION_PLACEHOLDER = 'WREX.EDITOR_WITH_MENTION_PLACEHOLDER',
    /**
     * @value AI generative content
     */
    GENERATE_CONTENT_LABEL = 'WREX_AI.GENERATE_CONTENT_LABEL',
    /**
     * @value Link
     * @description The label of the button to insert a link in the rich text.
     */
    INSERT_BUTTON_LABEL = 'WREX_LINK.INSERT_BUTTON_LABEL',
    /**
     * @value Insert element
     */
    INSERT_ELEMENT = 'WREX_CORE.INSERT_ELEMENT',
    /**
     * @value Original text
     * @description Title of the post generative AI section showing the original text input from the user, so that the user can compare it with the AI Suggestion.
     */
    ORIGINAL_TEXT = 'WREX_AI.ORIGINAL_TEXT',
    /**
     * @value Provide a more in-depth explanation for this statement: %SELECTED_TEXT%
     */
    PROMPT_REFINE_LENGTHEN = 'WREX_AI.PROMPT_REFINE_LENGTHEN',
    /**
     * @value Shorten this text while maintaining its core message: %SELECTED_TEXT%
     */
    PROMPT_REFINE_SHORTEN = 'WREX_AI.PROMPT_REFINE_SHORTEN',
    /**
     * @value Rewrite this sentence for better flow: %SELECTED_TEXT%
     */
    PROMPT_REFINE_STYLE = 'WREX_AI.PROMPT_REFINE_STYLE',
    /**
     * @value Make this sentence more %TYPE%: %SELECTED_TEXT%
     */
    PROMPT_REFINE_TONE = 'WREX_AI.PROMPT_REFINE_TONE',
    /**
     * @value The visibility of all thumbnails is public, they can be seen by everyone
     */
    THUMBNAIL_VISIBILITY = 'JOURNEYS_CORE.THUMBNAIL_VISIBILITY',
    /**
     * @value You are about to permanently delete this image gallery. This action is irreversible.
     */
    WARNING_DELETE = 'WREX_IMAGE_GALLERY.WARNING_DELETE',
}
